export default __webpack_public_path__ + "static/media/item-2-mob.0c90d3f4.png";